<template>
    <on-click-outside :do="close">
        <div ref="filter" class="relative">
            <button @click.stop.prevent="switchPopper"
                    class="flex justify-start pl-5 w-64 text-center items-center outline-none text-grey-darkest font-bold rounded-full">
                <p>{{options[selectedOption].name}}</p>
                <font-awesome-icon
                        :icon="['far', 'angle-down']"
                        fixed-width
                        class="arrow text-grey-dark cursor-pointer -mr-3"
                ></font-awesome-icon>
            </button>
            <div ref="elements" v-show="showFilter" class="absolute bg-white shadow-md rounded-lg w-full py-1">
                <div class="w-full py-2  flex flex-row justify-between px-4 text-center cursor-pointer select-none font-medium selectedLabel"
                     v-for="(option, id, key) in filterOptions" :key="key" @click.prevent="changeOption(option.id)">
                    <div class="">{{option.name}}</div>
                    <img src="@/assets/SVG/tick.svg" alt="">
                </div>
            </div>

        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '@/views/OnClickOutside';
import debounce from 'lodash/debounce';
import clone from 'lodash/cloneDeep';

export default {
  name: 'filter-teams',
  components: { OnClickOutside },
  data() {
    return {
      showFilter: null,
      hideSelectboxHandler: null,
      options: {
        0: { name: 'По количеству участий', value: '-play_count' },
        1: { name: 'По названию команды А-Я', value: 'name' },
      },
      selectedOption: 1,
    };
  },
  created() {
    if (this.$route.query['&sort']) {
      if (this.$route.query['&sort'].indexOf('name') > -1) {
        this.selectedOption = 1;
      } else {
        this.selectedOption = 0;
      }
    }

    this.hideSelectboxHandler = () => {
      this.showFilter = false;
    };
  },
  watch: {
    showBox() {
      if (this.showFilter) {
        this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
    selectedOption(val) {
      this.newSort(this.options[val].value);
    },
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  computed: {
    filterOptions() {
      const teamFilter = [];
      for (let i = 0; i < Object.keys(this.options).length; i++) {
        if (i !== this.selectedOption) {
          teamFilter.push({ name: this.options[i].name, id: i });
        }
      }
      return teamFilter;
    },
  },
  methods: {
    close() {
      if (!this.showFilter) {
        return;
      }
      this.showFilter = false;
    },
    switchPopper() {
      this.showFilter = !this.showFilter;
      if (this.showFilter) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    changeOption(id) {
      this.selectedOption = id;
      this.showFilter = false;
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.filter, this.$refs.elements, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    newSort: debounce(function (sort) {
      const query = clone(this.$route.query);
      query['&sort'] = `${sort},-id`;
      const searchQuery = {};
      for (const key in query) {
        if (query[key] === '') {
          continue;
        }
        searchQuery[key] = query[key];
      }
      this.$router.push({ query: searchQuery });
    }, 800),
  },
};
</script>

<style scoped lang="less">
    .selectedLabel {
        color: #333333;
        &:hover {
            color: white;
            background-color: #BD006C;
        }
    }
</style>
